
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import BackTop from '@/common/backtop.vue';
import { Component, Vue } from 'vue-property-decorator';
import { getPreferenCoupon, receiveCoupon } from '@/services/http';
import { readCookie, dateTimeFormatter } from '@/tools/tools';

@Component({
  components: {
    Header,
    Footer,
    BackTop
  },
  filters: {
    dateTimeFormatter(value: number) {
      return dateTimeFormatter(value);
    }
  }
})
export default class extends Vue {
  couponList: any[] = [] // 优惠券列表

  created() {
    this.getCouponList();
  }

  // 获取优惠券列表
  async getCouponList() {
    const res: any = await getPreferenCoupon({
      companyId: 1
    });
    if (res.data.code === 100) {
      this.couponList = res.data.data || [];
    }
  }

  // 领取优惠券
  async receiveCoupon(item: any) {
    if (item.receive) return;
    if (readCookie('accessToken')) {
      const res: any = await receiveCoupon({
        couponId: item.id,
        companyId: 1
      });
      if (res.data.code === 100) {
        this.$message.success('领取成功');
        this.getCouponList();
      } else {
        this.$message.error(res.data.message);
      }
    } else {
      this.$router.push(`/login?redirect=${this.$route.fullPath}`);
    }
  }
}
